import { render, staticRenderFns } from "./MagicWandIcon.vue?vue&type=template&id=733dd091"
import script from "./MagicWandIcon.vue?vue&type=script&lang=js"
export * from "./MagicWandIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports